import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BatchRule, BatchRuleType } from "../../domain/batch-rule";
import { UserService } from "../../domain/user-service";
import { Logger } from "../../infrastructure/logger";
import { BatchRulesRepository } from "../../domain/batch-rules-repository";
import { UI } from "../../services/ui.service";

@Component({
  selector: "icn-edit-batch-rule",
  templateUrl: "./edit-rule.html",
  styleUrls: ["./edit-rule.scss"],
})
export class EditBatchRuleComponent implements OnInit {
  readonly bottom = 'bottom';

  constructor(
    private userService: UserService,
    private batchRulesRepository: BatchRulesRepository,
    private logger: Logger,
    private ui: UI,
  ) {}

  detachRelatedSubtitles = false;
  @Input() rule = new BatchRule(
    undefined,
    undefined,
    "",
    "",
    BatchRuleType.Video,
    undefined,
    "en",
    "en",
    25,
    0,
  );

  @Output() close = new EventEmitter<{}>();

  languages: [{ code: string; name: string }];

  ngOnInit(): void {
    this.languages = this.userService.getCurrentUser().languages;
  }

  onSave() {
    const promise: any = !this.rule.id
      ? () => this.batchRulesRepository.addRule(this.rule)
      : () =>
          this.batchRulesRepository.updateRule(
            this.rule,
            this.detachRelatedSubtitles,
          );

    promise()
      .then(() => {
        this.close.emit();
      })
      .catch((err) => {
        this.logger.error(err);
      });
  }
}
